// Process [[wiki links]]
// Converts [[Page Name]] to a link with href based on normalized page name

import type StateInline from '../state-inline'

export default function wikilink(state: StateInline, silent: boolean): boolean {
  const start = state.pos
  const max = state.posMax

  // Check if we start with [[
  if (state.src.charCodeAt(start) !== 0x5b /* [ */) return false
  if (state.src.charCodeAt(start + 1) !== 0x5b /* [ */) return false

  const labelStart = start + 2
  let pos = labelStart
  let found = false

  // Find the closing ]] (with reasonable scan limit to avoid pathological cases)
  // Wiki link labels shouldn't be more than 200 characters
  const scanMax = Math.min(max, labelStart + 200)
  while (pos < scanMax) {
    const ch = state.src.charCodeAt(pos)

    // Bail out on newlines - wiki links should be single line
    if (ch === 0x0a /* \n */) return false

    if (ch === 0x5d /* ] */ && state.src.charCodeAt(pos + 1) === 0x5d /* ] */) {
      found = true
      break
    }
    pos++
  }

  // No closing ]] found
  if (!found) return false

  const labelEnd = pos
  const label = state.src.slice(labelStart, labelEnd)

  // Empty label not allowed
  if (label.trim().length === 0) return false

  // Normalize the label to create href: "Test Page" -> "test_page"
  const href = label.trim().toLowerCase().replace(/\s+/g, '_')

  if (!silent) {
    const token_open = state.push('wikilink_open', 'a', 1)
    token_open.attrs = [['href', href]]
    token_open.markup = '[['
    token_open.meta = { label }

    const token_text = state.push('text', '', 0)
    token_text.content = label

    const token_close = state.push('wikilink_close', 'a', -1)
    token_close.markup = ']]'
  }

  state.pos = labelEnd + 2
  return true
}
